import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Avatar, Menu, Dropdown, Modal, Popover, Button, Badge, Alert, Typography } from 'antd';
import { showMessage } from '@/utils/notificationHelper';
import Notifications from '@/components/Notification';
import ThemeToggle from '@/components/ThemeToggle';

import {
  AppstoreOutlined,
  SettingOutlined,
  UserOutlined,
  LogoutOutlined,
  DeleteOutlined,
  AuditOutlined,
  BellTwoTone,
  ExclamationCircleOutlined,
  CompassTwoTone,
  CompassOutlined,
} from '@ant-design/icons';
import photo from '@/style/images/photo.png';
import { checkImage } from '@/request';

import { selectCurrentAdmin } from '@/redux/auth/selectors';
import history from '@/utils/history';
import axios from 'axios';
import uniqueId from '@/utils/uinqueId';

import { API_BASE_URL } from '@/config/serverApiConfig';
import { logout } from '@/redux/auth/actions';
import NotificationComponent from '@/pages/InterviewNotifications';
import { useNotifications } from '@/hooks/useNotifications';
import { useLocation, Link } from 'react-router-dom/cjs/react-router-dom.min';

const { confirm } = Modal;

export default function HeaderContent() {
  const dispatch = useDispatch();
  const [logoutModalVisible, setLogoutModalVisible] = useState(false);
  const [isPopUpForNot, setIsPopUpForNot] = useState(false);
  const [hasFetched, setHasFetched] = useState(false)
  const currentAdmin = useSelector(selectCurrentAdmin);
  const location = useLocation();

  // Use the custom hook for notifications (handles socket, initial fetch, and updates)
  const {
    notifications,
    unreadCount,
    tabCounts,
    activeType,
    fetchNotifications,
    fetchCounts,
    markAsRead,
    markAllAsRead,
    deleteNotification,
    handleTabChange,
    loadMore,
    hasMore,
    isLoading
  } = useNotifications();

  // Loading state is now managed inside the hook.
  // We can add isNotificationLoading to the hook if needed, but for now we'll simulate it or ignore it.
  const [isNotificationLoading, setIsNotificationLoading] = useState(false);

  const [resetLoading, setResetLoading] = useState(false);
  const showLogoutModal = () => {
    confirm({
      title: 'Are you sure you want to log out? ',
      icon: <LogoutOutlined />,
      content: 'Your session will be securely closed.',
      centered: true,

      onOk() {
        const audio = new Audio('/wrong-answer-129254.mp3');
        audio.play();
        return new Promise((resolve, reject) => {
          setTimeout(() => {
            // Dispatch the logout action
            dispatch(logout());
            resolve();
          }, 1000);
        })
          .then(() => {
            showMessage.success('Logout successful!');
          })
          .catch(() => {
            showMessage.error('Logout failed!');
          });
      },
      onCancel() {
        // Handle the "Cancel" button click
      },
    });
  };


  const showPasswordResetConfirm = () => {
    confirm({
      title: "Reset Your Password",
      icon: <ExclamationCircleOutlined />,
      content: (
        <div>
          <p>A password reset link will be sent to your registered email address:</p>
          <Typography.Text strong style={{ color: '#1890ff' }}>
            {currentAdmin.email}
          </Typography.Text>
          <p style={{ marginTop: 16 }}>
            The reset link will expire in 2 minutes for security reasons.
          </p>
          <Alert
            message="Important"
            description="Please check your email inbox (and spam folder) after clicking OK."
            type="info"
            showIcon
            style={{ marginTop: 16 }}
          />
        </div>
      ),
      okText: "Send Reset Link",
      cancelText: "Cancel",
      onOk: handlePasswordReset,
      width: 520,
    });
  };

  const handlePasswordReset = async () => {
    try {
      setResetLoading(true);
      // Using your existing generatePasswordReset endpoint
      await axios.post("/auth/generate-reset", {
        employeeId: null,
        userId: currentAdmin?._id,

      });
      showMessage.success("Password reset link has been sent to your email!");
    } catch (error) {
      console.error("Error sending reset email:", error);
      showMessage.error(error.response?.data?.message || "Failed to send reset email");
    } finally {
      setResetLoading(false);
    }
  };


  const srcImgProfile = checkImage(API_BASE_URL + currentAdmin?.photo)
    ? API_BASE_URL + currentAdmin?.photo
    : photo;

  const profileDropdown = (
    <div className="profileDropdown whiteBox shadow" style={{ minWidth: '200px' }}>
      <div className="pad15" onClick={() => history.push('/admin')} style={{ cursor: 'pointer' }}>
        <Avatar
          size="large"
          className="last"
          src={srcImgProfile}
          style={{ color: '#eef2f4', backgroundColor: '#1c99f5' }}
        >
          {currentAdmin?.name.toUpperCase()}
        </Avatar>
        <div className="info">
          <p className="strong">
            {currentAdmin?.name} {currentAdmin?.surname}
          </p>
          <p>{currentAdmin?.email}</p>
        </div>
      </div>

      <div>
        <Menu>
          {/* <Menu.Item
            icon={<SettingOutlined />}
            key={`${uniqueId()}`}
            onClick={() => history.push('/admin')}
          >
            Registered Users
          </Menu.Item> */}
          {/* <Menu.Item
            icon={<SettingOutlined />}
            key={`${uniqueId()}`}
            onClick={() => history.push('/settings/')}
          >
            App Settings
          </Menu.Item> */}
        </Menu>
      </div>

      <div>
        {/* <Menu>
          <Menu.Item icon={<AuditOutlined />} onClick={() => history.push('/activity-scorecard')}>
            {' '}
            View Scorecard
          </Menu.Item>
        </Menu> */}
      </div>
      <div>
        <Menu>
          <Menu.Item icon={<UserOutlined />} key={`${uniqueId()}`}>
            <Link to={'/my-profile'}>My Profile</Link>
          </Menu.Item>
          <Menu.Item
            icon={<CompassOutlined />}
            key={uniqueId()}
            onClick={() => {
              showPasswordResetConfirm()
            }}
          >
            Reset Password
          </Menu.Item>
          <Menu.Item icon={<LogoutOutlined />} key={`${uniqueId()}`} onClick={showLogoutModal}>
            Logout
          </Menu.Item>
        </Menu>
      </div>
    </div>
  );

  //   useEffect(() => {
  //     // Hook handles data fetching and socket connection internally
  //   }, []);
  function handleNotificaitons(params) {
    // setIsPopUpForNot(!isPopUpForNot)
  }
  return (
    <div
      className="headerIcon"
    // style={{ position: 'absolute', right: 0, zIndex: '99', cursor: 'pointer' }}
    >
      <Dropdown overlay={profileDropdown} trigger={['click']} placement="bottomRight">
        {/* <Badge dot> */}
        {/* {!location.pathname?.includes('/announcement-feeds') ? <AnnouncementBanner /> : null} */}

        <Avatar
          className="last"
          src={srcImgProfile}
          style={{ color: '#eef2f4', backgroundColor: '#1c99f5' }}
        >
          {currentAdmin?.name.charAt(0).toUpperCase()}
        </Avatar>
      </Dropdown>

      <div
        style={{
          marginTop: '14px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-end',
          gap: '8px',
        }}
      >
        <ThemeToggle />
        <Popover
          content={
            <NotificationComponent
              notifications={notifications}
              tabCounts={tabCounts}
              activeType={activeType}
              handleTabChange={handleTabChange}
              markAsRead={markAsRead}
              markAllAsRead={markAllAsRead}
              fetchNotifications={fetchNotifications}
              fetchCounts={fetchCounts}
              deleteNotification={deleteNotification}
              loadMore={loadMore}
              hasMore={hasMore}
              isNotificationLoading={isLoading}
              hasFetched={true}
            />
          }
          title="Notifications"
          trigger="click"
        >
          <Badge count={unreadCount > 0 ? unreadCount : 0} overflowCount={999}>
            <Button
              icon={<BellTwoTone twoToneColor="#1890ff" />}
              shape="circle"
            />
          </Badge>
        </Popover>
      </div>
      {/* <Popover content={<InterviewNotifications isNotificaitonLoading={isNotificaitonLoading} setIsNotificaitonLoading={setIsNotificaitonLoading} />} title="Notifications" trigger="click">
          <Button icon={<BellTwoTone />} shape="circle" />
        </Popover> */}
    </div >
  );
}

//  <Avatar icon={<AppstoreOutlined />} />
// <Dropdown overlay={<Notifications />} trigger={['click']} placement="bottomRight">
//   {/* <Badge dot> */}
//   <Avatar icon={<BellOutlined />} />

//   {/* </Badge> */}
// </Dropdown>;
